"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'settings.general.title': '常规设置',
    'settings.general.description': '配置您的应用程序设置和集成',
    'settings.general.tabs.googleDrive': 'Google Drive',
    'settings.general.tabs.general': '常规',
    'settings.general.tabs.apiKeys': 'API 密钥',
    'settings.general.tabs.rag': 'RAG 设置',
    'settings.general.tabs.credit': '积分设置',
    'settings.general.tabs.socialMedia': '社交媒体',
    'settings.general.generalSettings.comingSoon': '常规设置即将推出。',
    'settings.general.apiKeys.comingSoon': 'API 密钥管理即将推出。',
    'settings.general.chatLearning.title': '聊天学习摘要',
    'settings.general.chatLearning.description': '管理您的个性化AI学习摘要。这些信息有助于AI提供更好、更有针对性的回答。',
    'settings.general.chatLearning.summaryLabel': '学习摘要',
    'settings.general.chatLearning.summaryPlaceholder': '输入或编辑关于您的偏好、背景和重要细节的信息，这些信息应该有助于AI更好地协助您...',
    'settings.general.chatLearning.summaryHelp': '此摘要会根据您的对话自动更新。您可以手动编辑它以包含特定的偏好或背景。',
    'settings.general.save': '保存设置',
    'settings.general.reload': '重新加载',
    'settings.general.savedSuccessfully': '常规设置保存成功',
    'settings.general.failedToSave': '保存常规设置失败',
    'settings.general.failedToLoad': '加载常规设置失败',
};
